import { useEffect, useState, type ReactElement } from 'react';
import { plugin, debug, t, LightGrid } from 'light-component';
import { Require } from '../component';
import styles from './style.module.less';
import type { StarOptionProps } from './types';

export function WidgetStarOption(props: StarOptionProps): ReactElement {
  debug.widget('form staroption', props);
  const defaultOptions = [
    { value: 1 },
    { value: 2 },
    { value: 3 },
    { value: 4 },
    { value: 5 }
  ];
  const [options, setOptions] = useState(props.value ?? defaultOptions);

  const onOptionsChange = (value: StarOptionProps['value']): void => {
    const [star] = value;
    if (star == null) {
      return;
    }
    setOptions(value);
    const result = value?.map(item => ({
      value: Number(item.value)
    }));
    props?.onChange?.(result);
  };

  const keyGenerator = (): string => {
    if (options.length < 9) {
      return `${options.length + 1}`;
    }
    return String(options.length + 1);
  };

  useEffect(() => {
    if (props.value == null || props?.value?.length === 0) {
      setOptions(defaultOptions);
      props?.onChange?.(defaultOptions);
      return;
    }

    setOptions(props.value);
  }, [props.value]);

  return (
    <div className={props.className ?? styles.propertyItem}>
      <div className={styles.input}>
        <Require require={props.require} />
        <span className={styles.title}>{t(props.title)}</span>
      </div>
      <div className={styles.option}>
        <LightGrid
          keyField='value'
          keyGenerator={keyGenerator}
          data={options.map((item, idx) => ({ value: item.value, index: `${idx}` }))}
          onChange={value => onOptionsChange(value)}
          options={[
            { type: 'number', name: 'value', width: '100%', title: t('分数') }
          ]}
          dragAlign='left'
        />
      </div>
    </div>
  );
}

plugin.register({ kind: 'widget', type: 'staroption', component: WidgetStarOption });
